import React from 'react';
import { Container, Typography, Link, Stack, Divider, Box } from '@mui/material';
import { useCustomTheme } from '../context/ThemeContext';

// Importa le icone che useremo
import LocationOnOutlinedIcon from '@mui/icons-material/LocationOnOutlined';
import PhoneOutlinedIcon from '@mui/icons-material/PhoneOutlined';
import MailOutlineIcon from '@mui/icons-material/MailOutline';
import WhatsAppIcon from '@mui/icons-material/WhatsApp';

export default function Footer() {
  const { themeSettings } = useCustomTheme();
  const numeroTelefono = "3341627843";
  const prefisso = "39";
  
  // 1. Definisco l'indirizzo per creare il link a Google Maps
  const indirizzo = "Via Lodorina 20, Erba";
  const googleMapsUrl = `https://www.google.com/maps/search/?api=1&query=${encodeURIComponent(indirizzo)}`;

  return (
    <Box component="footer" sx={{ width: '100%', mt: 'auto' }}>
      <Box sx={{ bgcolor: themeSettings?.footer_bg || 'background.paper', pt: 4, pb: '132px' }}>
        <Container maxWidth="md">
          <Stack
            spacing={1.5}
            alignItems="center"
          >
            {/* 2. Sostituisco la Typography con un Link */}
            <Stack direction="row" spacing={1} alignItems="center">
              <LocationOnOutlinedIcon fontSize="small" color="action" />
              <Link 
                href={googleMapsUrl}
                underline="hover"
                target="_blank"
                rel="noopener noreferrer"
              >
                Corso di Yoga a Erba: via Lodorina 20
              </Link>
            </Stack>

            {/* Telefono con link corretto */}
            <Stack direction="row" spacing={1} alignItems="center">
              <PhoneOutlinedIcon fontSize="small" color="action" />
              <Link href={`tel:+${prefisso}${numeroTelefono}`} underline="hover">
                334 162 7843
              </Link>
            </Stack>

            {/* WhatsApp */}
            <Stack direction="row" spacing={1} alignItems="center">
              <WhatsAppIcon fontSize="small" color="action" />
              <Link 
                href={`https://wa.me/${prefisso}${numeroTelefono}`} 
                underline="hover"
                target="_blank"
                rel="noopener noreferrer"
              >
                Chatta su WhatsApp
              </Link>
            </Stack>

            {/* Mail con link corretto */}
            <Stack direction="row" spacing={1} alignItems="center">
              <MailOutlineIcon fontSize="small" color="action" />
              <Link href="mailto:bellulaura57@gmail.com" underline="hover">
                bellulaura57@gmail.com
              </Link>
            </Stack>
          </Stack>
        </Container>
      </Box>
    </Box>
  );
}